module.exports = __webpack_public_path__ + "img/VRC.56c54133.svg";